/*
 * "YYYY-MM-DD" value for <input type="date"> built from the LOCAL calendar
 * date. `new Date().toISOString().slice(0, 10)` is the UTC date, which is the
 * previous day for the first hours of every day in a timezone ahead of UTC
 * (Turkey is UTC+3), so form defaults like "collection date" or "invoice date"
 * showed yesterday between 00:00 and 03:00.
 */
export const toLocalDateInputValue = (date = new Date()) => {
    const pad = (value) => String(value).padStart(2, "0");

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};
